<template>
    <div>
        <div class="titlebox">
            <img src="../assets/img/titleLeft.png" alt="" class="title-img" v-if="color != 'white'">

            <img src="../assets/img/left-white.png" alt="" class="title-img" v-if="color == 'white'">

            <span class="title-text" :style="{'color':color
                
            }">{{ props.title }}</span>
            <img src="../assets/img/titleRight.png" alt="" class="title-img" v-if="color != 'white'">
            <img src="../assets/img/right-white.png" alt="" class="title-img" v-if="color == 'white'">
        </div>




    </div>
</template>

<script lang='ts' setup>
import { reactive, toRefs, ref,defineProps } from 'vue'
const props = defineProps({
    title: {
        type: String,
        default: ''
    },
    color: {
        type: String,
        default: ''
    }
})


</script>
<style scoped>
.titlebox {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center
}

.title-text {
    color: #25243E;
    
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 44px;
    margin: 0 15px 0 15px;
}

.title-img {
    width: 47px;
    height: 18px;
}
</style>